module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "info",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.isBlankField),
      callback: function($$v) {
        _vm.isBlankField = $$v
      },
      expression: "isBlankField"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign fa-2x pull-left"
  }), _vm._v(" "), _c('p', {
    staticClass: "margin-top-5"
  }, [_vm._v("Please type something, the input field seems to be blank.")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span'), _vm._v(" "), (!_vm.user && (_vm.getSearchResults ? _vm.getSearchResults.length : 0) !== 0 && _vm.currentPlan) ? _c('h3', [_vm._v("Gain access to expert videos in the topics that interest you"), (!_vm.isNativeApp) ? _c('span', [_vm._v(" for just $" + _vm._s(_vm.currentPlan.amount) + " a month! ")]) : _c('span', [_vm._v("!")]), _vm._v(" "), _c('br'), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.redirectToSignUp
    }
  }, [_c('strong', [_vm._v("Start your free trial today")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "id": "search_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.initiateSearch.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contentToSearch),
      expression: "contentToSearch"
    }],
    attrs: {
      "type": "text",
      "placeholder": "What can we help you find?"
    },
    domProps: {
      "value": (_vm.contentToSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contentToSearch = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      border: '1px solid' + _vm.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 margin-top-40"
  }, [_c('transition', {
    attrs: {
      "name": "slide-search-fade"
    }
  }, [(_vm.isEmptyResponse) ? _c('div', {
    staticClass: "text-center text-muted margin-bottom-40"
  }, [_c('h1', [_vm._v("No result found for "), _c('strong', [_vm._v(_vm._s(_vm.enteredValue))]), _vm._v("!")])]) : _vm._e(), _vm._v(" "), ((_vm.getSearchResults ? _vm.getSearchResults.length : 0) !== 0) ? _c('div', {
    staticClass: "text-center text-success"
  }, [_c('h1', [_vm._v("Search results for "), _c('strong', [_vm._v(_vm._s(_vm.enteredValue))])])]) : _vm._e()])], 1)]), _vm._v(" "), (!(this.searchResults === null && this.searchEventResults === null && this.searchPlaylistResult === null)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 margin-bottom-40"
  }, [_c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "tabs m-b-45"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.videos
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('videos')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("videos ("), _c('b', [_vm._v(_vm._s(_vm.getSearchPlaylistResults && _vm.getSearchResults.length ? _vm.getSearchResults.length : 0))]), _vm._v(")")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.events
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('events')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v(" Events ("), _c('b', [_vm._v(_vm._s(_vm.getSearchExpertResults && _vm.getSearchExpertResults.length ? _vm.getSearchExpertResults.length : 0))]), _vm._v(")")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.playlists
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('playlists')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("Playlists ("), _c('b', [_vm._v(_vm._s(_vm.getSearchPlaylistResults && _vm.getSearchPlaylistResults.userPlaylists && _vm.getSearchPlaylistResults.userPlaylists.length ? _vm.getSearchPlaylistResults.userPlaylists.length : 0))]), _vm._v(")")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.videos
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [((_vm.getSearchResults ? _vm.getSearchResults.length : 0) !== 0) ? _c('div', {
    staticClass: "container__header"
  }, [_c('div', {
    staticClass: "container__header-item",
    on: {
      "click": function($event) {
        return _vm.sort('expertname')
      }
    }
  }, [_vm._v("\n                                    Sort By Expert\n                                    "), _c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container__header-item",
    on: {
      "click": function($event) {
        return _vm.sort('_score')
      }
    }
  }, [_vm._v("\n                                    Sort By Rating\n                                    "), _c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row video-row"
  }, _vm._l((_vm.limitTo(_vm.searchResults)), function(result) {
    return (_vm.searchResults && _vm.searchResults) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [(_vm.user) ? _c('div', [_c('router-link', {
      staticClass: "nounderline",
      attrs: {
        "to": {
          path: '/watch/' + result.mediaid + '/' + result.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
        }
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": result.image,
        "alt": result.title,
        "title": result.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(result.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title"
    }, [_vm._v(_vm._s(result.title))])])], 1) : _c('div', [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": result.image,
        "alt": result.title,
        "title": result.title
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(result.videoCode, result.title)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(result.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title",
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(result.videoCode, result.title)
        }
      }
    }, [_vm._v(_vm._s(result.title))])]), _vm._v(" "), (_vm.user) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": result.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(result.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, result)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(result, playlist, _vm.verifyVideoExists(playlist, result))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                    "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(result.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(result.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(result.mediaid)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.getAuthUserVideos) ? _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(result)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(result)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.events
    },
    attrs: {
      "id": "tabs-2"
    }
  }, [_c('div', {
    staticClass: "row video-row"
  }, _vm._l((_vm.limitTo(_vm.searchEventResults)), function(result) {
    return (_vm.searchEventResults && _vm.searchEventResults.length > 0) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [(_vm.user) ? _c('div', [_c('router-link', {
      staticClass: "nounderline",
      attrs: {
        "to": {
          path: '/tonearchive/' + result.eventId + '/play/1/' + result.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
        }
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": result.img_url,
        "alt": result.title,
        "title": result.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(result.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title"
    }, [_vm._v(_vm._s(result.title))])])], 1) : _c('div', [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": result.img_url,
        "alt": result.title,
        "title": result.title
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(result.videoCode, result.title)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(result.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title",
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(result.videoCode, result.title)
        }
      }
    }, [_vm._v(_vm._s(result.title))])]), _vm._v(" "), (_vm.user) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": result.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(result.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(3, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, result)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(result, playlist, _vm.verifyVideoExists(playlist, result))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(result.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(result.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(result.mediaid)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.getAuthUserVideos) ? _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(result)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(result)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.playlists
    },
    attrs: {
      "id": "tabs-3"
    }
  }, [_c('div', {
    staticClass: "row video-row"
  }, [(_vm.getSearchPlaylistResults && _vm.getSearchPlaylistResults.userPlaylists && _vm.getSearchPlaylistResults.userPlaylists.length > 0) ? _c('span', _vm._l((_vm.limitTo(_vm.searchPlaylistResult)), function(playlist) {
    return (playlist.userPlaylistVideos) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', [_c('div', {
      staticClass: "viderowraper image-container",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [(playlist.userPlaylistType === 1) ? _c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)
        }
      }
    }) : _vm._e(), _vm._v(" "), (playlist.userPlaylistType === 2) ? _c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }) : _vm._e(), _vm._v(" "), (playlist.corporationId > 0) ? _c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(playlist.allVidDurInSeconds)))])]), _vm._v(" "), (playlist.userPlaylistType === 1) ? _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)
        }
      }
    }, [_vm._v(" " + _vm._s(playlist.title))]) : _vm._e(), _vm._v(" "), (playlist.userPlaylistType === 2) ? _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }, [_vm._v(" " + _vm._s(playlist.title))]) : _vm._e(), _vm._v(" "), (playlist.corporationId > 0) ? _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }, [_vm._v(" " + _vm._s(playlist.title))]) : _vm._e()])]) : _vm._e()
  }), 0) : _vm._e()])])]), _vm._v(" "), (_vm.tabs.videos) ? _c('span', [((_vm.getSearchResults ? _vm.getSearchResults.length : 0) > 6) ? _c('div', [_c('pagination', {
    ref: "searchResults",
    attrs: {
      "for": "searchResults",
      "per-page": _vm.pageLimit,
      "records": _vm.getSearchResults.length
    },
    on: {
      "paginate": function($event) {
        return _vm.setPage('videos', $event, 1)
      }
    },
    model: {
      value: (_vm.page.videos),
      callback: function($$v) {
        _vm.$set(_vm.page, "videos", $$v)
      },
      expression: "page.videos"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabs.events) ? _c('span', [((_vm.getSearchExpertResults ? _vm.getSearchExpertResults.length : 0) > 6) ? _c('div', [_c('pagination', {
    ref: "searchEventResults",
    attrs: {
      "for": "searchEventResults",
      "per-page": _vm.pageLimit,
      "records": _vm.getSearchExpertResults.length
    },
    on: {
      "paginate": function($event) {
        return _vm.setPage('events', $event, 2)
      }
    },
    model: {
      value: (_vm.page.events),
      callback: function($$v) {
        _vm.$set(_vm.page, "events", $$v)
      },
      expression: "page.events"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabs.playlists) ? _c('span', [((_vm.getSearchPlaylistResults && _vm.getSearchPlaylistResults.userPlaylists && _vm.getSearchPlaylistResults.userPlaylists.length ? _vm.getSearchPlaylistResults.userPlaylists.length : 0) > 6) ? _c('div', [_c('pagination', {
    ref: "searchPlaylistResult",
    attrs: {
      "for": "searchPlaylistResult",
      "per-page": _vm.pageLimit,
      "records": _vm.getSearchPlaylistResults.userPlaylists.length
    },
    on: {
      "paginate": function($event) {
        return _vm.setPage('playlists', $event, 3)
      }
    },
    model: {
      value: (_vm.page.playlists),
      callback: function($$v) {
        _vm.$set(_vm.page, "playlists", $$v)
      },
      expression: "page.playlists"
    }
  })], 1) : _vm._e()]) : _vm._e()])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69e48300"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Search.vue